import {FC} from "react";
import Congrats from "../Congrat/index";
import AdminHeader from "../SubComponents/AdminHeader";
import Footer from "../SubComponents/Footer";
import { Divider, Box } from "@material-ui/core";
import InvestStepper from "./InvestStepper";

const InvestSuccess:FC = () => {
  return (
    <>
      <AdminHeader isProject={true} />
      <InvestStepper  />
      <Box mt={3}>
        <Divider />
      </Box>
      <Congrats invest={true} />
      <Footer />
    </>
  );
};

export default InvestSuccess;